var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-my-institute-edit"}},[(_vm.institute_data)?_c('vx-card',{staticClass:"mb-base",attrs:{"title":"학원 상세 정보"}},[_c('my-institute-edit-form',{staticClass:"mt-4",attrs:{"data":_vm.institute_data}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }